import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import EntidadForm from './EntidadForm';
import EntidadList from './EntidadList';

const EntidadManager = (props) => {

  const { list } = props;
  const [editing, setEditing] = useState({});
  const [showForm, setShowForm] = useState(true);

  const handleOnAdd = (item) => {
    props.onEntidadAdd(item);

    setShowForm(false);
  };

  const handleOnEdit = (item) => {
    setEditing(item);

    props.onChangeList(item, list.filter((value) => value.id !== item.id));

    setShowForm(true);

    setTimeout(() => {
      setEditing({});
    }, 500);
  }

  const handleOnClick = () => {
    setShowForm(!showForm);
  };

  const handleOnListChange = (item) => {
    props.onChangeList(item, list.filter((value) => item.id !== value.id));
  }

  const handleOnContabilidadAdd = (item) => {
    props.onContabilidadAdd(item);
  }

  return (
    <>
      { !showForm && (
        <div className="py-2 mr-3">
          <p>¿Quieres agregar una nueva Entidad ?</p>

          <Button
            variant="secondary"
            onClick={ handleOnClick }
          >
            Nueva Entidad
          </Button>

        </div>
      )}

      { !!showForm && (
        <EntidadForm
          data={ editing }
          onAdd={ handleOnAdd }
          ruleData={ props.ruleData }
        />
      )}

      <EntidadList
        data={ list }
        onEdit={ handleOnEdit }
        onListChange={ handleOnListChange }
        onContabilidadAdd={ handleOnContabilidadAdd }
      />
    </>
  );
};

export default EntidadManager;
